/**
 * Metric Conversion Chart — TypeScript entry point.
 * Handles hidden-iframe print flow.
 */
import { initIframePrint } from './shared/iframe-print';

function init(): void {
    initIframePrint({
        formId: 'mccPrintForm',
        iframeId: 'mccPrintFrame',
        buttonId: 'mccPrintBtn',
        readyLabel: '<i class="bi bi-printer me-2" aria-hidden="true"></i>Print Metric Chart',
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
